import { render, staticRenderFns } from "./ProductExamplePicker.vue?vue&type=template&id=a239a1da&scoped=true"
import script from "./ProductExamplePicker.vue?vue&type=script&lang=js"
export * from "./ProductExamplePicker.vue?vue&type=script&lang=js"
import style0 from "./ProductExamplePicker.vue?vue&type=style&index=0&id=a239a1da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a239a1da",
  null
  
)

export default component.exports